'use strict';

var GridToolbarStrategyListingController = function GridToolbarStrategyListingController($scope, strategiesStateService, DataRetrieverConstants) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateShown = false;
  $scope.isStrategySelected = false;
  $scope.isAlertsTab = $scope.mode === DataRetrieverConstants.ALERT_STRATEGY_LISTING_MODE;
  $scope.onRowSelection = function (event, selectedRows) {
    $scope.isDeleteButtonShown = strategiesStateService.isDeleteButtonVisible();
    $scope.isDuplicateShown = strategiesStateService.isDuplicateButtonVisible();
    if ($scope.isDeleteButtonShown) {
      $scope.$broadcast('strategy-listing:strategiesToRemove', selectedRows);
    }
  };
  $scope.duplicateStrategy = function () {
    $scope.$emit('strategy-listing:duplicateStrategy', $scope.selectedRow);
  };
};
GridToolbarStrategyListingController.$inject = ['$scope', 'StrategiesStateService', 'DataRetrieverConstantsService'];
module.exports = GridToolbarStrategyListingController;